import t from "./index.vue2.js";
import "./index.vue3.js";
import o from "../../../../_virtual/_plugin-vue_export-helper.js";
const r = /* @__PURE__ */ o(t, [["__scopeId", "data-v-fbb6ae15"]]);
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/inputTypeItem/index.vue.js
// module id = 1214
// module chunks = 41